// LANDING PAGE
// Script autonome, chargé uniquement sur le template page-landing.php

(function () {

    //marge au-dessus des sections ciblées (le header n'est pas sticky sur la landing)
    function decalageHeader() {
        return window.innerWidth < 960 ? 24 : 40;
    }


    //ANCRES
    //intercepté en phase de capture pour passer avant le smooth scroll global (offset fixe de 50px)
    document.addEventListener('click', function (event) {
        var lien = event.target.closest('.landing_body a[href^="#"]');

        if (!lien || lien.hash.length < 2)
            return;

        var cible = document.getElementById(lien.hash.substring(1));

        if (!cible)
            return;

        event.preventDefault();
        event.stopPropagation();

        window.scrollTo({
            top: cible.getBoundingClientRect().top + window.scrollY - decalageHeader(),
            behavior: 'smooth'
        });

        history.replaceState(null, '', lien.hash);
    }, true);


    //SOMMAIRE : section active
    var liensSommaire = document.querySelectorAll('.landing_sommaire li a');
    var sections = document.querySelectorAll('.landing_section');

    if (liensSommaire.length && sections.length && 'IntersectionObserver' in window) {

        var observerSommaire = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting)
                    return;

                liensSommaire.forEach(function (lien) {
                    lien.classList.toggle('active', lien.hash === '#' + entry.target.id);
                });
            });
        }, {rootMargin: '-45% 0px -50% 0px'});

        sections.forEach(function (section) {
            observerSommaire.observe(section);
        });
    }


    //BARRE CTA MOBILE
    //visible une fois le post-it sorti de l'écran, masquée quand le formulaire est à l'écran
    var barre = document.querySelector('.landing_barre_cta');
    var postit = document.querySelector('.landing_hdp .postit');
    var formulaire = document.querySelector('.landing_formulaire');

    if (barre && 'IntersectionObserver' in window) {

        var etat = {postit: !!postit, formulaire: false};

        function majBarre() {
            barre.classList.toggle('visible', !etat.postit && !etat.formulaire);
        }

        var observerBarre = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.target === postit)
                    etat.postit = entry.isIntersecting;
                else
                    etat.formulaire = entry.isIntersecting;
            });

            majBarre();
        });

        if (postit)
            observerBarre.observe(postit);

        if (formulaire)
            observerBarre.observe(formulaire);

        majBarre();
    }


    //PROGRAMME : remplissage du rail au scroll
    var timelines = document.querySelectorAll('.landing_timeline');

    if (timelines.length) {

        var ticking = false;

        function majTimelines() {
            var repere = window.innerHeight * .6;

            timelines.forEach(function (timeline) {
                var rect = timeline.getBoundingClientRect();
                var progress = Math.min(Math.max((repere - rect.top) / rect.height, 0), 1);

                timeline.style.setProperty('--progress', progress.toFixed(3));

                timeline.querySelectorAll(':scope > .creneau').forEach(function (creneau) {
                    creneau.classList.toggle('passe', creneau.getBoundingClientRect().top < repere);
                });
            });

            ticking = false;
        }

        window.addEventListener('scroll', function () {
            if (!ticking) {
                window.requestAnimationFrame(majTimelines);
                ticking = true;
            }
        }, {passive: true});

        window.addEventListener('resize', majTimelines);
        majTimelines();
    }

})();
